/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCase } from './InternalApiCase';
import {
    InternalApiCaseFromJSON,
    InternalApiCaseFromJSONTyped,
    InternalApiCaseToJSON,
    InternalApiCaseToJSONTyped,
} from './InternalApiCase';

/**
 * 
 * @export
 * @interface InternalApiCasePage
 */
export interface InternalApiCasePage {
    /**
     * 
     * @type {number}
     * @memberof InternalApiCasePage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiCasePage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiCasePage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiCase>}
     * @memberof InternalApiCasePage
     */
    content: Array<InternalApiCase>;
}

/**
 * Check if a given object implements the InternalApiCasePage interface.
 */
export function instanceOfInternalApiCasePage(value: object): value is InternalApiCasePage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiCasePageFromJSON(json: any): InternalApiCasePage {
    return InternalApiCasePageFromJSONTyped(json, false);
}

export function InternalApiCasePageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCasePage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiCaseFromJSON)),
    };
}

export function InternalApiCasePageToJSON(json: any): InternalApiCasePage {
    return InternalApiCasePageToJSONTyped(json, false);
}

export function InternalApiCasePageToJSONTyped(value?: InternalApiCasePage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiCaseToJSON)),
    };
}

